import { Service } from "./index";
/**
 * WEB - [订单列表]条件查询当前用户/商户订单列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function findOrderListWeb(data) {
  return Service({
    url: "/amall_order/order/sale/findOrderListWeb",
    method: "post",
    data: data
  });
}
/**
 * SERVICE - [通用API]根据订单号查询订单
 * @export
 * @param {*} data
 * @return {*}
 */
export function findOrderByOrdersn(data) {
  return Service({
    url: "/amall_order/order/sale/findOrderByOrdersn",
    method: "post",
    params: data
  });
}
/**
 * APPLET - [订单列表]根据订单编码查询订单详情
 * @export
 * @param {*} data
 * @return {*}
 */
export function findOrderItemByOrderSn(data) {
  return Service({
    url: "/amall_order/order/sale/findOrderItemByOrderSn",
    method: "post",
    params: data
  });
}
/**
 * WEB_APPLET - [订单列表]根据订单编码查询支付流水
 * @export
 * @param {*} data
 * @return {*}
 */
export function findPayByOrderSn(data) {
  return Service({
    url: "/amall_order/order/sale/findPayByOrderSn",
    method: "post",
    params: data
  });
}
/**
 * [小程序商城][关联工程]获取关联第三方订单项目列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getRelateThirdPartyOrderProjectList(data) {
  return Service({
    url: "/amall_order/order/manage/getRelateThirdPartyOrderProjectList",
    method: "get",
    params: data
  });
}
/**
 * WEB - [支付]订单价格立减
 * @export
 * @param {*} data
 * @return {*}
 */
export function orderBgoMoney(data) {
  return Service({
    url: "/amall_order/order/sale/orderBgoMoney",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}
/**
 * APPLET - [订单列表]根据订单编号/合单编号查询支付信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function findPayInfo(data) {
  return Service({
    url: "/amall_order/order/sale/findPayInfo",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}
/**
 * WEB - [支付]线下收款
 * @export
 * @param {*} data
 * @return {*}
 */
export function OfflinePay(data) {
  return Service({
    url: "/amall_order/order/sale/OfflinePay",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}
/**
 * WEB - [订单发货]订单发货
 * @export
 * @param {*} data
 * @return {*}
 */
export function deliverGoods(data) {
  return Service({
    url: "/amall_order/order/sale/deliverGoods",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}

/**
 * [总后台][流水中心-工程订单]新增订单
 * @export
 * @param {*} data
 * @return {*}
 */
export function addOrder(data) {
  return Service({
    url: "/amall_order/order/manage/addOrder",
    method: "post",
    data: data
  });
}

/**
 * [小程序商城][关联工程]获取商户未关联第三方订单项目列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getShopNoRelateThirdPartyOrderProjectList(data) {
  return Service({
    url: "/amall_order/order/manage/getShopNoRelateThirdPartyOrderProjectList",
    method: "get",
    params: data
  });
}

/**
 * [小程序商城][关联工程]销售订单与工程订单关联
 * @export
 * @param {*} data
 * @return {*}
 */
export function saleOrderRelateWithProjectOrder(data) {
  return Service({
    url: "/amall_order/order/manage/saleOrderRelateWithProjectOrder",
    method: "post",
    params: data
  });
}
/**
 * WEB - [结算]商户结算
 * @export
 * @param {*} data
 * @return {*}
 */
export function settlement(data) {
  return Service({
    url: "/amall_order/order/sale/settlement",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}
/**
 * [总后台][流水中心-工程订单]获取订单管理列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getOrderManageList(data) {
  return Service({
    url: "/amall_order/order/manage/getOrderManageList",
    method: "get",
    params: data
  });
}

/**
 * [总后台][流水中心-工程订单]获取工程订单详情
 * @export
 * @param {*} data
 * @return {*}
 */
export function getOrderDetail(data) {
  return Service({
    url: "amall_order/order/manage/getOrderDetail",
    method: "get",
    params: data
  });
}
/**
 * [总后台][流水中心-工程订单]更新订单
 * @export
 * @param {*} data
 * @return {*}
 */
export function updateOrder(data) {
  return Service({
    url: "amall_order/order/manage/updateOrder",
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    // },
    method: "post",
    data: data
  });
}
/**
 * 获取需求分类列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getDemandCateList(data) {
  return Service({
    url: "amall_order/orderCenter/getDemandCateList",
    method: "get",
    data: data
  });
}
/**
 * [商户后台][需求管理-招标管理]添加招标项目
 * @export
 * @param {*} data
 * @return {*}
 */
export function addBddingProject(data) {
  return Service({
    url: "amall_order/orderCenter/addBddingProject",
    method: "post",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    data: data
  });
}
/**
 * [商户后台，总后台][需求管理-招标管理]获取招标项目管理列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getBddingProjectManageList(data) {
  return Service({
    url: "amall_order/orderCenter/getBddingProjectManageList",
    method: "get",
    params: data
  });
}
/**
 *[][]获取招标项目详情
 * @export
 * @param {*} data
 * @return {*}
 */
export function getBddingProjectDetail(data) {
  return Service({
    url: "amall_order/orderCenter/getBddingProjectDetail",
    method: "get",
    params: data
  });
}
/**
 *[商户后台][需求管理-招标管理]更新招标项目
 * @export
 * @param {*} data
 * @return {*}
 */
export function updateBddingProject(data) {
  return Service({
    url: "amall_order/orderCenter/updateBddingProject",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}
/**
 *[商户后台][需求管理-招标管理]更新招标项目状态
 * @export
 * @param {*} data
 * @return {*}
 */
export function updateBddingProjectStatus(data) {
  return Service({
    url: "amall_order/orderCenter/updateBddingProjectStatus",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}
/**
 *[商户后台，总后台][需求管理-投标报名]获取招标项目报名列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getBddingProjectApplyList(data) {
  return Service({
    url: "amall_order/orderCenter/getBddingProjectApplyList",
    method: "get",
    params: data
  });
}
/**
 *[商户后台][需求管理-投标报名]招标项目与工程订单关联
 * @export
 * @param {*} data
 * @return {*}
 */
export function biddingProjectRelateWithProjectOrder(data) {
  return Service({
    url:
      "amall_order/order/manage/biddingProjectRelateWithProjectOrder?projectOrderIdList=" +
      data.projectIdList,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data.bidding_project_id
  });
}
/**
 *[商户后台][需求管理-投标报名]获取商户未关联招标项目项目列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getShopNoRelateBiddingProjectProjectList(data) {
  return Service({
    url: "amall_order/order/manage/getShopNoRelateBiddingProjectProjectList",
    method: "get",
    params: data
  });
}
/**
 *[商户后台][需求管理-投标报名]招标项目接单
 * @export
 * @param {*} data
 * @return {*}
 */
export function bddingProjectReceiveOrder(data) {
  return Service({
    url: "amall_order/orderCenter/bddingProjectReceiveOrder",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}
/**
 *[商户后台][工程订单]设置工程款
 * @export
 * @param {*} data
 * @return {*}
 */
export function setProjectMoney(data) {
  return Service({
    url: "amall_order/order/manage/setProjectMoney",
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    // },
    method: "post",
    data: data
  });
}
/**
 *[商户后台][工程订单]获取工程款操作记录列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getProjectMoneyOperationRecordList(data) {
  return Service({
    url: "amall_order/order/manage/getProjectMoneyOperationRecordList",
    method: "get",
    params: data
  });
}
/**
 *[商户后台][工程订单]添加工程款操作记录
 * @export
 * @param {*} data
 * @return {*}
 */
export function addProjectMoneyOperationRecord(data) {
  return Service({
    url: "amall_order/order/manage/addProjectMoneyOperationRecord",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}
/**
 *[商户后台][工程款-结算-支付页面]获取需求包款
 * @export
 * @param {*} data
 * @return {*}
 */
export function getDemandPackageMoney(data) {
  return Service({
    url: "amall_order/order/manage/getDemandPackageMoney",
    method: "get",
    params: data
  });
}
/**
 * [商户后台][工程款-结算-支付页面]需求包款支付
 * @export
 * @param {*} data
 * @return {*}
 */
export function demandPackageMoneyPay(data) {
  return Service({
    url: "amall_order/order/manage/demandPackageMoneyPay",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}
/**
 * [商户后台][工程订单]完结工程款
 * @export
 * @param {*} data
 * @return {*}
 */
export function endProjectMoney(data) {
  return Service({
    url: "amall_order/order/manage/endProjectMoney",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8"
    },
    method: "post",
    data: data
  });
}
/**
 * [总后台][需求管理-服务产品管理]获取需求分类管理列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getDemandCateManageList(data) {
  return Service({
    url: "amall_order/orderCenter/getDemandCateManageList",
    method: "get",
    params: data
  });
}
/**
 * [总后台][需求管理-服务产品管理]获取需求分类关联品牌列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getDemandCateRelateBrandList(data) {
  return Service({
    url: "amall_order/orderCenter/getDemandCateRelateBrandList",
    method: "get",
    params: data
  });
}
/**
 * [总后台][需求管理-服务产品管理]获取系列列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getSeriesList(data) {
  return Service({
    url: "amall_order/orderCenter/getSeriesList",
    method: "get",
    params: data
  });
}
/**
 * [总后台][需求管理-服务产品管理]获取关联报价列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getRelateQuotedPriceList(data) {
  return Service({
    url: "amall_order/orderCenter/getRelateQuotedPriceList",
    method: "get",
    params: data
  });
}

/**
 * 获取单据分类
 * @export
 * @param {*} data
 * @return {*}
 */
export function getBillsType(data) {
  return Service({
    url: "amall_order/order/manage/getInvoiceSortList",
    method: "get",
    params: data
  });
}

/**
 * 获取单据分类下的列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getBillsTypeList(data) {
  return Service({
    url: "amall_order/order/manage/getInvoiceList",
    method: "get",
    params: data
  });
}


/**
 * 获取快速筛选任务列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getTaskList(data) {
  return Service({
    url: "amall_order/order/manage/getInitialTaskList",
    method: "get",
    params: data
  });
}

/**
 * 新增任务
 * @export
 * @param {*} data
 * @return {*}
 */
export function addTask(data) {
  return Service({
    url: "amall_order/order/manage/addTask",
    method: "POST",
    data: data
  });
}

/**
 * 查询是否有单据
 * @export
 * @param {*} data
 * @return {*}
 */
export function getDocumentsList(data) {
  return Service({
    url: "amall_order/order/manage/getAllOrderInvoiceConfigureList",
    method: "GET",
    params: data
  });
}

/**
 * 新增单据
 * @export
 * @param {*} data
 * @return {*}
 */
export function addDocumentsList(data) {
  return Service({
    url: "amall_order/order/manage/addOrderInvoiceConfigure",
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  });
}

/**
 * 修改单据是必传还是不必传
 * @export
 * @param {*} data
 * @return {*}
 */
export function editDocumentsStatus(data) {
  return Service({
    url: "amall_order/order/manage/updateOrderInvoiceConfigureIfRequired",
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  });
}

/**
 * 删除单据
 * @export
 * @param {*} data
 * @return {*}
 */
export function deleteDocumentsStatus(data) {
  return Service({
    url: "amall_order/order/manage/deleteOrderInvoiceConfigure",
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  });
}

/**
 * 获取上传图配置列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getConfigImg(data) {
  return Service({
    url: "amall_order/order/manage/getTaskUploadImageConfigList",
    method: "GET",
    params: data
  });
}


/**
 * 获取上传图配置模版（根据任务ID和工程ID查询当前任务要求模板）
 * @export
 * @param {*} data
 * @return {*}
 */
export function getTaskConfigImg(data) {
  return Service({
    url: "amall_order/order/template/findTaskClaimByTaskId",
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  });
}


/**
 * 添加上传图
 * @export
 * @param {*} data
 * @return {*}
 */
export function addTaskConfigImg(data) {
  return Service({
    url: "amall_order/order/template/updateClaimTemplate",
    method: "POST",
    data: data
  });
}


/**
 * 获取该工程配置信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function getProjectConfig(data) {
  return Service({
    url: "amall_order/order/template/findOrderConfigByOrderId",
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  });
}


/**
 * 修改工程项目验收流程配置
 * @export
 * @param {*} data
 * @return {*}
 */
export function editProjectConfig(data) {
  return Service({
    url: "amall_order/order/template/updateOrderConfig",
    method: "POST",
    data: data
  });
}

/**
 * 查询商户所有成员
 * @export
 * @param {*} data
 * @return {*}
 */
export function getShopUser(data) {
  return Service({
    url: "amall_user/shop/findShopMamberAll",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "POST",
    data: data
  });
}

/**
 * 查询服务商所有成员
 * @export
 * @param {*} data
 * @return {*}
 */
 export function getServiceUser(data) {
  return Service({
    url: "amall_user/service/findServiceMamberAll",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "POST",
    data: data
  });
}

/**
 * 提交派单
 * @export
 * @param {*} data
 * @return {*}
 */
export function SendSingle(data) {
  return Service({
    url: "amall_order/order/manage/projectDispatchServiceProviderUpdate",
    method: "POST",
    data: data
  });
}


/**
 * 获取审批代办列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getCheckList(data) {
  return Service({
    url: "amall_order/order/manage/getCheckList",
    method: "GET",
    params: data
  });
}


/**
 * 获取施工任务列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getTaskListData(data) {
  return Service({
    url: "amall_order/order/manage/getTaskList",
    method: "GET",
    params: data
  });
}


/**
 * 获取施工记录
 * @export
 * @param {*} data
 * @return {*}
 */
export function getConstructionRecords(data) {
  return Service({
    url: "amall_order/order/manage/getProjectConstructionRecordList",
    method: "GET",
    params: data
  });
}



/**
 * [施工记录-开/关]更新施工记录状态
 * @export
 * @param {*} data
 * @return {*}
 */
export function changStatus(data) {
  return Service({
    url: "amall_order/order/manage/updateConstructionRecordStatus",
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  });
}



/**
 * 获取施工任务详情
 * @export
 * @param {*} data
 * @return {*}
 */
export function getTaskListDetail(data) {
  return Service({
    url: "amall_order/order/manage/getTaskConstructionRecordList",
    method: "GET",
    params: data
  });
}



/**
 * 获取设备材料
 * @export
 * @param {*} data
 * @return {*}
 */
export function getEquipment(data) {
  return Service({
    url: "amall_order/order/manage/getEquipmentMaterialList",
    method: "GET",
    params: data
  });
}



/**
 * [施工明细-设备材料]保存设备材料清单
 * @export
 * @param {*} data
 * @return {*}
 */
export function saveEquipment(data) {
  return Service({
    url: "amall_order/order/manage/saveEquipmentMaterialList",
    method: "POST",
    data: data
  });
}


/**
 * 根据项目id获取参与人员和负责人员信息和监理
 * @export
 * @param {*} data
 * @return {*}
 */
export function getProPeople(data) {
  return Service({
    url: "amall_user/service/findBuildMember",
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  });
}


/**
 *  项目编辑施工成员/负责人/监理成员列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function addProPeople(data) {
  return Service({
    url: "/amall_user/service/updateBuildMember",
    method: "POST",
    data: data
  });
}


/**
 *  项目删除工程成员
 * @export
 * @param {*} data
 * @return {*}
 */
export function deleteProPeople(data) {
  return Service({
    url: "/amall_user/service/deleteBuildMember",
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  });
}

/**
 * 更换工程成员
 * @export
 * @param {*} data
 * @return {*}
 */
export function replaceProPeople(data) {
  return Service({
    url: "/amall_user/service/replaceBuildMember",
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  });
}


/**
 * 获取审核详情
 * @export
 * @param {*} data
 * @return {*}
 */
export function getExauitDetail(data) {
  return Service({
    url: "/amall_order/order/manage/getCheckDetail",
    method: "GET",
    params: data
  });
}

/**
 * 根据商品规格获取对应的设备材料
 * @export
 * @param {*} data
 * @return {*}
 */
export function getShopIdFacility(data) {
  return Service({
    url: "/amall_goods/goods/manage/getSpecEquipmentMaterialList",
    method: "GET",
    params: data
  });
}


/**
 *  获取通用模板列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function findTemplate(data) {
  return Service({
    url: "/amall_order/order/template/findCurrencyTemplate",
    method: "POST",
    data: data
  });
}

/**
 *  添加通用模板
 * @export
 * @param {*} data
 * @return {*}
 */
export function addTemplate(data) {
  return Service({
    url: "/amall_order/order/template/addCurrencyTemplate",
    method: "POST",
    data: data
  });
}

/**
 *  根据通用模板ID查询通用模板信息
 * @export
 * @param {*} data
 * @return {*}
 */
export function findTemplateById(data) {
  return Service({
    url: "/amall_order/order/template/findTemplateById",
    method: "POST",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    data: data
  });
}


/**
 *  根据模板ID删除模板
 * @export
 * @param {*} data
 * @return {*}
 */
export function deleteTemplate(data) {
  return Service({
    url: "/amall_order/order/template/deleteTemplate",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "POST",
    data: data
  });
}


/**
 *  获取获取施工标准管理列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getConstructionStandardManageList(data) {
  return Service({
    url: "/amall_order/order/manage/getConstructionStandardManageList",
    method: "GET",
    params: data
  });
}


/**
 *  添加施工标准
 * @export
 * @param {*} data
 * @return {*}
 */
export function addConstructionStandard(data) {
  return Service({
    url: "/amall_order/order/manage/addConstructionStandard",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "POST",
    data: data
  });
}


/**
 *  编辑施工标准
 * @export
 * @param {*} data
 * @return {*}
 */
export function updateConstructionStandard(data) {
  return Service({
    url: "/amall_order/order/manage/updateConstructionStandard",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "POST",
    data: data
  });
}

/**
 *  删除施工标准
 * @export
 * @param {*} data
 * @return {*}
 */
export function deleteConstructionStandard(data) {
  return Service({
    url: "/amall_order/order/manage/deleteConstructionStandard",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "POST",
    data: data
  });
}


/**
 *  获取工程施工有页面标准列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getOrderStandardManageList(data) {
  return Service({
    url: "/amall_order/order/manage/getOrderConstructionStandardList",
    method: "GET",
    params: data
  });
}

/**
 *  获取工程施工标准弹框选择列表
 * @export
 * @param {*} data
 * @return {*}
 */
export function getChooseStandardManageList(data) {
  return Service({
    url: "/amall_order/order/manage/getConstructionStandardSelectList",
    method: "GET",
    params: data
  });
}



/**
 *  添加工程施工标准
 * @export
 * @param {*} data
 * @return {*}
 */
export function addeOrderConstructionStandard(data) {
  return Service({
    url: "/amall_order/order/manage/addeOrderConstructionStandard",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "POST",
    data: data
  });
}

/**
 *  删除工程施工标准
 * @export
 * @param {*} data
 * @return {*}
 */
export function deleteOrderConstructionStandard(data) {
  return Service({
    url: "/amall_order/order/manage/deleteOrderConstructionStandard",
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    },
    method: "POST",
    data: data
  });
}


/**
 *  [工程款结算明细]获取结算进度列表
 * @export
 * @param {*} data
 * @return {*}
 */
 export function getSettlementProgressList(data) {
  return Service({
    url: "/amall_order/order/manage/getSettlementProgressList",
    method: "GET",
    params: data
  });
}

/**
 *  [工程款结算明细]获取结算明细列表
 * @export
 * @param {*} data
 * @return {*}
 */
 export function getSettlementDetailList(data) {
  return Service({
    url: "/amall_order/order/manage/getSettlementDetailList",
    method: "GET",
    params: data
  });
}

/**
 *  [工程-设置工程模板]获取工程模板选择列表
 * @export
 * @param {*} data
 * @return {*}
 */
 export function getPutImageTemplateSelectList(data) {
  return Service({
    url: "/amall_order/order/manage/getPutImageTemplateSelectList",
    method: "GET",
    params: data
  });
}




// WEBPACK FOOTER //
// ./src/service/order.js